import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/port-oconnor")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Port O\'Connor, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Port O\'Connor & Calhoun County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Port O\'Connor, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Port O\'Connor and Calhoun County.",
      keywords: "awnings Port O\'Connor, awning company Port O\'Connor, custom awnings Port O\'Connor, sail shades Port O\'Connor, patio covers Port O\'Connor, pergola covers Port O\'Connor, metal awnings Port O\'Connor, canvas awnings Port O\'Connor, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Port O\'Connor", "Calhoun County"),
  }),
  component: () => <CityHomePage city="Port O\'Connor" region="Calhoun County" />,
});
